import React from 'react'

export default function RunTaskSectionTextComponent({ onValidate, section, index, length, onComplete, layout }) {
    return (
        <div>
            {layout.name ? <div className='text-start'><b>{layout.name}</b></div> : <></>}
            {layout.text ? <div dangerouslySetInnerHTML={{__html: layout.text}} /> : <></>}
        </div>
    )
}